export interface IAgency {
    code: string;
    contact: string;
    contactperson: string;
    country: string;
    email: string;
    logo: any;
    name: string;
    phone: string;
    headline?: string;
    language?: string;
}
export const initialAgency: IAgency = {
    code: "",
    contact: "",
    contactperson: "",
    country: "",
    email: "",
    logo: { url: "" },
    name: "",
    phone: ""
}

// Add and edit Agency interfaces
export interface IImageStatusType {
    [key: string]: { status: 'UPLOADING' | 'SUCCESS' | 'FAILED' };
}

export interface IUploadImageSettings {
    code: string;
    base64: string;
    retry: number;
}

export interface IAgencyUIState {
    agencyInfo: IAgency;
    loading: boolean,
    submitted: boolean;
    beforeUpdate: IAgency | null;
    loadingMessage: string;
    checkingCode: boolean;
    isEditAgency: boolean;
    invalidCode: boolean;
    logoSelected: boolean;
    imageUploadingStatus: IImageStatusType;
    agencySaved: boolean;
};

export interface IAgencyUIProps {
    history: any;
    location: any;
    match: any;
};

export enum AgencyCodeValidator {
    CHECKINGCODE = 'Checking agency code...',
    INVALIDCODE = 'This agency code already exist, please try another one',
    AVAILABLECODE = 'Agency code available'
}


// WEBPACK FOOTER //
// ./src/share/types/agency.ts